import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';

@Component({
  imports: [RouterModule, TranslateModule, ToastModule],
  selector: 'app-root',
  template: `
    <router-outlet/>
    <p-toast/>
  `
})
export class App {
  protected title = 'patient';
}
